import * as Yup from "yup";
import { DOMAIN_NAME_REGEX } from "../constants";

export const vtexstep0 = Yup.object({
  email: Yup.string()
    .email("Must be a valid email")
    .required("Email is Required"),
  business_name: Yup.string()
    .required("Store Name is Required")
    .when("store_name_exist", {
      is: true,
      then: () => Yup.string().max(0, "Store Name Is Already Taken"),
    }),
  domain_name: Yup.string()
    .matches(DOMAIN_NAME_REGEX, "Must be a valid Domain")
    .required("Domain is Required"),
  first_name: Yup.string().required("First Name is Required"),
  last_name: Yup.string().required("Last Name is Required"),
  vtex_business_name: Yup.string().required("Business Name is Required")
  .when("business_name_exist", {
      is: true,
      then: () => Yup.string().max(0, "Business name is Already Taken"),
    }),
  designation: Yup.string().required("Designation is Required"),
  phoneC1: Yup.string()
    .min(7, "Must be a valid Phone Number")
    .required("Phone number for primary contact is Required"),
});

export const contact2vtexstep0 = Yup.object({
  first_name: Yup.string().required(
    "First Name for primary contact is Required"
  ),
  last_name: Yup.string().required("Last Name for primary contact is Required"),
  designation: Yup.string().required(
    "Designation for primary contact is Required"
  ),
  phoneC1: Yup.string()
    .min(7, "Must be a valid Phone Number")
    .required("Phone number for primary contact is Required"),
  firstNameC2: Yup.string().required(
    "First Name for secondary contact is Required"
  ),
  lastNameC2: Yup.string().required(
    "Last Name for secondary contact is Required"
  ),
  designationC2: Yup.string().required(
    "Designation for secondary contact is Required"
  ),
  phoneC2: Yup.string()
    .min(7, "Must be a valid Phone Number")
    .required("Phone number for secondary contact is Required"),
  business_name: Yup.string()
    .required("Store Name is Required")
    .when("store_name_exist", {
      is: true,
      then: () => Yup.string().max(0, "Store Name Is Already Taken"),
    }),
  domain_name: Yup.string()
    .matches(DOMAIN_NAME_REGEX, "Must be a valid Domain")
    .required("Domain is Required"),

  vtex_business_name: Yup.string().required("Business Name is Required"),
  email: Yup.string()
    .email("Must be a valid email")
    .required("Email for primary contact is Required")
    .when("email_exists", {
      is: true,
      then: () => Yup.string().max(0, "Email Already Exists."),
    }),
  emailC2: Yup.string()
    .email("Must be a valid email")
    .required("Email for secondary contact is Required")
    .when("email_C2_exists", {
      is: true,
      then: () => Yup.string().max(0, "Email Already Exists."),
    }),
});

export const step0 = Yup.object({
  email: Yup.string()
    .email("Must be a valid email")
    .required("Email is Required"),
  business_name: Yup.string().required("Business Name is Required"),
  domain_name: Yup.string()
    .matches(DOMAIN_NAME_REGEX, "Must be a valid Domain")
    .required("Domain is Required"),
  first_name: Yup.string().required("First Name is Required"),
  last_name: Yup.string().required("Last Name is Required"),
});

export const step1 = Yup.object({
  theme: Yup.number().required("Theme is Required"),
  website_name: Yup.string().required("Website is Required"),
  domain: Yup.string().required("Domain is Required"),
});

export const vtexstep1 = Yup.object({
  contract: Yup.string(),
});
export const vtexstep1manual = Yup.object({
  contract: Yup.string().required("Contract is Required"),
});

export const step2 = Yup.object({
  country: Yup.number().required("Country is Required"),
  state: Yup.number().required("State is Required"),
  city: Yup.string().required("City is Required"),
  street: Yup.string().required("street# is Required"),
  zip: Yup.string().required("Zip code is Required"),
  phone: Yup.string()
    .min(7, "Must be a valid Phone Number")
    .required("Phone number is Required"),
});
export const vtexstep2 = Yup.object({
  country: Yup.number().required("Country is Required"),
  governate: Yup.number().required("Governorate is Required"),
  wilayat: Yup.number().required("Wilayat is Required"),
  area: Yup.number().required("Area is Required"),
  city: Yup.string().required("City is Required"),
  street: Yup.string().required("street# is Required"),
  zip: Yup.string().required("Zip code is Required"),
  phone: Yup.string()
    .min(7, "Must be a valid Phone Number")
    .required("Phone number is Required"),
});
export const vtexstep2Pickup = Yup.object({
  country: Yup.number().required("Country is Required"),
  governate: Yup.number().required("Governorate is Required"),
  wilayat: Yup.number().required("Wilayat is Required"),
  area: Yup.number().required("Area is Required"),
  city: Yup.string().required("City is Required"),
  street: Yup.string().required("street# is Required"),
  zip: Yup.string().required("Zip code is Required"),
  phone: Yup.string()
    .min(7, "Must be a valid Phone Number")
    .required("Phone number is Required"),

  countryB: Yup.number().required("Country is Required"),
  governateB: Yup.number().required("Governorate is Required"),
  wilayatB: Yup.number().required("Wilayat is Required"),
  areaB: Yup.number().required("Area is Required"),
  cityB: Yup.string().required("City is Required"),
  streetB: Yup.string().required("street# is Required"),
  zipB: Yup.string().required("Zip code is Required"),
  phoneB: Yup.string()
    .min(7, "Must be a valid Phone Number")
    .required("Phone number is Required"),
});

export const step3 = Yup.object({
  acc_holder_name: Yup.string().required("Account Holder is Required"),
  account_number: Yup.string()
    .required("Account Number is Required")
    .matches(/^\d+$/, "Only digits are allowed"), // Ensures only digits are allowed
    // .when("account_number_exist", {
    //   is: true,
    //   then: () => Yup.string().max(0, "Account Number Already Exist"),
    // }),
  branch_name: Yup.string().required("Branch Name is Required"),
  bank_id: Yup.number().required("Bank is Required"),
  cr: Yup.string().required("CR is Required"),
  iban: Yup.string().when("isVTEX", {
    is: true,
    then: () => Yup.string().required("IBAN Number is Required"),
  }),
  cr_number: Yup.string().when("isVTEX", {
    is: true,
    then: () =>
      Yup.string().required("Commercial Registration Number is Required"),
  }),
  cr_expiry_date: Yup.string().when("isVTEX", {
    is: true,
    then: () =>
      Yup.date().required("Commercial Registration Expiry is Required"),
  }),
  // vat_number: Yup.string().when("isVTEX", {
  //   is: true,
  //   then: () => Yup.string().required("VAT Number is Required"),
  // }),
  // vat_expiry_date: Yup.string().when("isVTEX", {
  //   is: true,
  //   then: () => Yup.date().required("VAT Expiry is Required"),
  // }),
  cc: Yup.string().when("isVTEX", {
    is: true,
    then: () => Yup.string().required("CC is Required"),
  }),
  // vc: Yup.string(),
});
export const step3VAT = Yup.object({
  acc_holder_name: Yup.string().required("Business Account Name is Required"),
  account_number: Yup.string()
    .required("Account Number is Required")
    .matches(/^\d+$/, "Only digits are allowed") // Ensures only digits (0-9)
    .when("account_number_exist", {
      is: true,
      then: () => Yup.string().max(0, "Account Number Already Exist"),
    }),
  branch_name: Yup.string().required("Branch Name is Required"),
  bank_id: Yup.number().required("Bank is Required"),
  cr: Yup.string().required("CR is Required"),
  iban: Yup.string().when("isVTEX", {
    is: true,
    then: () => Yup.string().required("IBAN Number is Required"),
  }),
  cr_number: Yup.string().when("isVTEX", {
    is: true,
    then: () =>
      Yup.string().required("Commercial Registration Number is Required"),
  }),
  cr_expiry_date: Yup.string().when("isVTEX", {
    is: true,
    then: () =>
      Yup.date().required("Commercial Registration Expiry is Required"),
  }),
  vat_number: Yup.string().when("isVTEX", {
    is: true,
    then: () => Yup.string().required("VAT Number is Required"),
  }),
  vat_expiry_date: Yup.string().when("isVTEX", {
    is: true,
    then: () => Yup.date().required("VAT Expiry is Required"),
  }),
  cc: Yup.string().when("isVTEX", {
    is: true,
    then: () => Yup.string().required("CC is Required"),
  }),
  vc: Yup.string().when("isVTEX", {
    is: true,
    then: () => Yup.string().required("VC is Required"),
  }),
});

export const onBoardingValidationSchema = (
  isVTEX,
  isSecondaryContact,
  isPickupAddress,
  submissionType,
  isVATAvailable,
  activeTab
) => {
  // Step 0 schema selection based on VTEX and secondary contact

  const step0Schema = isVTEX
    ? isSecondaryContact
      ? contact2vtexstep0
      : vtexstep0
    : step0;
  const step2Schema = isVTEX
    ? isPickupAddress
      ? vtexstep2Pickup
      : vtexstep2
    : step2;
  // Step 1 schema selection based on VTEX
  const step1Schema = isVTEX
    ? submissionType === "manual"
      ? vtexstep1manual
      : vtexstep1
    : step1;

  const step3Schema = isVATAvailable ? step3VAT : step3;

  // Define schema sequences for VTEX and non-VTEX flows
  const vtexSchemas = [step0Schema, step3Schema, step1Schema, step2Schema];
  const nonVtexSchemas = [step0Schema, step1Schema, step2Schema, step3Schema];

  // Choose the appropriate schema sequence based on isVTEX
  const schemas = isVTEX ? vtexSchemas : nonVtexSchemas;

  // Return the schema for the current activeTab
  return schemas[activeTab];
};
